import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TrendingTopics = ({ topics, onTopicClick }) => {
  return (
    <div className="bg-card border border-border rounded-brand p-6">
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="TrendingUp" size={20} color="var(--color-primary)" />
        <h3 className="font-semibold">Trending Topics</h3>
      </div>
      <div className="space-y-3">
        {topics?.map((topic, index) => (
          <div
            key={topic?.id}
            className="flex items-center justify-between p-3 rounded-brand-sm hover:bg-muted/50 transition-brand cursor-pointer group"
            onClick={() => onTopicClick(topic?.tag)}
          >
            <div className="flex items-center space-x-3">
              <div className="flex items-center justify-center w-8 h-8 bg-primary/10 rounded-full text-primary font-semibold text-sm">
                {index + 1}
              </div>
              <div>
                <p className="font-medium group-hover:text-primary transition-brand">
                  #{topic?.tag}
                </p>
                <p className="text-xs text-muted-foreground">
                  {topic?.count} articles
                </p>
              </div>
            </div>
            
            <div className="flex items-center space-x-2">
              <div className="flex items-center space-x-1 text-xs text-success">
                <Icon name="ArrowUp" size={12} />
                <span>+{topic?.growth}%</span>
              </div>
              <Icon 
                name="ChevronRight" 
                size={16} 
                className="text-muted-foreground group-hover:text-primary transition-brand" 
              />
            </div>
          </div>
        ))}
      </div>
      <Button
        variant="outline"
        size="sm"
        fullWidth
        className="mt-4"
      >
        <Icon name="Hash" size={16} />
        <span className="ml-2">View All Topics</span>
      </Button>
    </div>
  );
};

export default TrendingTopics;